export class ProductCode {
  public static STH = 'STH';
  public static Employees = 'Employees';
  public static Guardian = 'Guardian';
  public static Kids = 'Kids';
}
